import { render, staticRenderFns } from "./AppSwitcherLocale.vue?vue&type=template&id=c4bd9eaa&scoped=true&"
import script from "./AppSwitcherLocale.vue?vue&type=script&lang=js&"
export * from "./AppSwitcherLocale.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitcherLocale.vue?vue&type=style&index=0&id=c4bd9eaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bd9eaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
